export const Dashboard = "Dashboard";
export const Configuration = "Configuration";
export const Menu = "Menu";
export const Master = "Master";
export const Project = "Project";
export const Product = "Product";
export const SalesOrder = "Sales Order";

export const Reports = "Reports"
export const JobCard = "JobCard"